<template>
  <f7-page name="register" @page:beforeremove="onPageBeforeRemove" @page:afterout="onPageAfterOut">
    <f7-navbar id="navbar">
      <f7-nav-left>
        <img :src=$session_logo />
      </f7-nav-left>
      <f7-nav-right>
        <f7-link href="#" color="red" iconF7="xmark_square" icon-only @click="terminate"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar id="toolbar" bottom>
      <small>{{ $t('copyright') }}
        DEV-({{ progress }}/{{ $session_client_id }})
      </small>
    </f7-toolbar>
    <span v-if="progress==9999">
    <f7-preloader></f7-preloader>
    </span>
    <!-- AGREEMENT -->
    <span v-if="progress<=10">
      <f7-block-title>{{ $t('consent-read') }}</f7-block-title>
      <f7-list>
        <f7-list-item :title="$t('agree-tc')"  link="/tc"></f7-list-item>
        <f7-list-item :title="$t('agree-note')" link="/note"></f7-list-item>
      </f7-list>
      <f7-block-title>{{ $t('consent-title') }}</f7-block-title>
      <f7-list>
        <f7-list-group>
          <f7-list-item>
            <span>{{ $t('agree-all') }}</span>
            <f7-toggle @change="agree" name="tc" value="tc"></f7-toggle>
          </f7-list-item>
          <f7-list-item>
            <span>{{ $t('agree-bio') }}</span>
            <f7-toggle @change="agree" name="bio" value="bio"></f7-toggle>
          </f7-list-item>
          <f7-list-item>
            <span>{{ $t('agree-document') }}: <em>{{ $t('romanian_identity_card') }}</em></span>
            <f7-toggle v-model:checked="id" @change="agree" name="id" value="id"></f7-toggle>
          </f7-list-item>
        </f7-list-group>
      </f7-list>
      <f7-block-footer>
        <p>{{ $t('all_info_mandatory') }}</p>
      </f7-block-footer>
    </span>
    <f7-block v-if="((!camera_mobile)&&(progress<=10))">
      <qrcode-vue :value="href" level="H" style="display:inline" render-as="svg" />
      <p>
      {{ $t('desktop-experience') }}
      </p>
    </f7-block>

    <!-- EMAIL AND PHONE NUMBER -->
    <span v-if="progress==20">
      <f7-block-title>{{ $t('personal_info') }}</f7-block-title>
      <f7-list no-hairlines-md>
        <f7-list-input
          type="tel"
          inputmode="numeric"
          :info="$t('national_id-info')"
          minlength=13
          maxlength=13
          required
          validate
          pattern="[0-9]+"
          :error-message="$t('national_id-error_message')"
          @input="national_id=$event.target.value"
          :label="$t('national_id-label')"
          :placeholder="$t('national_id-placeholder')"
          :onValidate="(isValid)=> setCnpValid(isValid)"
          :value="national_id"
          :readonly="national_id_ro"
        >
        </f7-list-input>

        <f7-list-input
          type="tel"
          inputmode="numeric"
          :info="$t('phone_number-info')"
          minlength=9
          maxlength=15
          required
          validate
          pattern="[0-9]+"
          :error-message="$t('phone_number-error-message')"
          @input="phone_number=$event.target.value"
          :label="$t('phone_number-label')"
          :placeholder="$t('phone_number-placeholder')"
          :onValidate="(isValid)=> setTelValid(isValid)"
          :value="phone_number"
        >
        </f7-list-input>
        <f7-list-input
          type="email"
          :placeholder="$t('email-placeholder', { account: 'nume.prenume', domain: 'domeniu'})"
          :info="$t('email-info')"
          minlength=5
          maxlength=64
          required
          validate
          :error-message="$t('email-error_message')"
          @input="email=$event.target.value"
          :label="$t('email-label')"
          :onValidate="(isValid)=> setEmailValid(isValid)"
          :value="email"
        >
        </f7-list-input>
      </f7-list>
      <f7-list>
        <f7-list-item 
          link="#" 
          :disabled="p2_next_disabled"
          @click="personal_validation"
        >{{ continue_btn_text }}</f7-list-item>
      </f7-list>
    </span>

    <!-- EMAIL CONFIRMATION -->
    <span v-if="progress==30">
      <f7-block-title>{{ $t('email_verify-title') }}</f7-block-title>
      <f7-block strong>
        <div style="display: flex; flex-direction: row; justify-content: center;">
          <v-otp-input
             ref="otpEmail"
             input-classes="otp-input"
             input-type="tel"
             inputmode="numeric"
             separator="&nbsp;"
             :num-inputs="4"
             :should-auto-focus="true"
             :is-input-num="true"
             :conditionalClass="['one', 'two', 'three', 'four']"
             :placeholder="['*', '*', '*', '*']"
             @on-change="printPinChangeEmail"
             @on-complete="verifyPinEmail"
             />
        </div>
      </f7-block>
      <f7-block-footer>
        {{ $t('email_verify-help') }}
      </f7-block-footer>
    </span>

    <!-- PHONE CONFIRMATION -->
    <span v-if="progress==40">
      <f7-block-title>{{ $t('phone_number_verify-title') }}</f7-block-title>
      <f7-block strong>
        <div style="display: flex; flex-direction: row; justify-content: center;">
          <v-otp-input
             ref="otpPhone"
             input-classes="otp-input"
             input-type="tel"
             inputmode="numeric"
             separator="&nbsp;"
             :num-inputs="4"
             :should-auto-focus="true"
             :is-input-num="true"
             :conditionalClass="['one', 'two', 'three', 'four']"
             :placeholder="['*', '*', '*', '*']"
             @on-complete="verifyPinPhone"
             />
        </div>
      </f7-block>
      <f7-block-footer>
        {{ $t('phone_number_verify-help') }}
      </f7-block-footer>
    </span>

    <!-- SELFIE AND IDENTITY CARD -->
    <span v-if="progress==50">
      <span v-if="is_mobile">
        <input type="file" capture="user" accept="image/*" @change="loadFile" ref="input_image" hidden/>
      </span>
      <f7-list media-list>
        <f7-list-item 
          link="#" 
          :title="$t('selfie-title')"
          :subtitle="$t('selfie-subtitle')"
          :text="$t('selfie-text')"
          @click="captureImage('SELFIE')">
          <template #media>
            <img src="../assets/selfie-man-160x160.jpg" style="height:80;width:80px;" />
          </template>
        </f7-list-item>
      </f7-list>
      <f7-block>
        <Markdown :source="markdown_selfie" />
      </f7-block>
    </span>

    <span v-if="progress==60||progress==65">
      <span v-if="is_mobile">
        <input type="file" capture="environment" accept="image/*" @change="loadFile" ref="input_image" hidden/>
      </span>
      <f7-list media-list>
        <f7-list-item 
          link="#" 
          :title="$t('identity-title')"
          :subtitle="$t('identity-subtitle')"
          :text="$t('identity-text')"
          @click="captureImage('IDENTITY')" >
          <template #media>
            <img src="../assets/identity-card-passport-h-160x160.jpg" style="height:80px;width:80px;" />
          </template>
        </f7-list-item>
      </f7-list>
      <f7-block v-if="progress==60">
        <Markdown :source="markdown_idcard" />
        <br><br>
        <img src="/images/id-tel-horizontal.webp"/>
      </f7-block>
      <f7-block v-if="progress==65">
        <Markdown :source="markdown_rotation" />
        <span v-if="progress==65">{{ idcard_orientation_text }}</span>
        <br><br>
        <span v-if="orientation=='H'">
          <img src="/images/id-tel-horizontal.webp"/>
        </span>
        <span v-if="orientation=='V'">
          <img src="/images/id-tel-vertical.webp"/>
        </span>
      </f7-block>
    </span>

    <!-- ADDRESS -->
    <span v-if="progress==75">
<!-- authority 
      <f7-block-title>{{ $t('address-authority') }}</f7-block-title>
      <f7-list no-hairlines-md>
        <f7-list-input 
          type="text" 
          :label="$t('address-authority')" 
          :value="authority"
           @change="authority=$event.target.value"
          >
        </f7-list-input>
      </f7-list>
authority -->
<!-- place of birth 
<span v-if="!pob_valid">
      <f7-block-title>{{ $t('address-place_of_birth') }}</f7-block-title>
      <f7-list no-hairlines-md>
        <f7-list-item 
          id="ss_pob_country"
          :disabled="pob_valid"
          :title="$t('address-birth_place_country')" smart-select 
          :smart-select-params="{searchbar: true, closeOnSelect:true, scrollToSelectedItem:true, setValueText:true}"
          >
          <select name="sel_pob_country" @change="pob_country=$event.target.value">
            <option v-for="item in country_list" :value="item.code" :selected="item.code==pob_country">{{ item.name }}</option>
          </select>
        </f7-list-item>
        <f7-list-item 
          v-if="pob_country==='RO'" 
          id="ss_pob_county"
          :disabled="pob_valid"
          :title="$t('address-birth_place_county')" smart-select 
          :smart-select-params="{searchbar: true, closeOnSelect:true, scrollToSelectedItem:true, setValueText:true}"
          >
          <select name="sel_pob_county" @change="pob_county=$event.target.value">
            <option v-for="item in county_list" :value="item.code" :selected="item.code==pob_county">{{ item.name }}</option>
          </select>
        </f7-list-item>
        <f7-list-item
          id="ss_pob_locality"
          v-if="pob_country==='RO'" 
          :disabled="pob_valid" 
          :title="$t('address-birth_place_locality')" smart-select
          :smart-select-params="{searchbar: true, closeOnSelect:true, scrollToSelectedItem:true, setValueText:true}"
          >
          <select name="sel_pob_locality" @change="pob_locality=$event.target.value">
            <option v-for="item in place_of_birth_list" :value="item.name">{{ item.name }}</option>
          </select>
        </f7-list-item>
        <f7-list-input 
          v-if="pob_country!='RO'" 
          type="text" 
          :disabled="pob_valid" 
          :placeholder="$t('without')" 
          :label="$t('address-birth_place_locality')" 
          :value="pob_locality"
           @change="pob_locality=$event.target.value"
          >
          </f7-list-input>
      </f7-list>
      <f7-block strong inset>
        {{ place_of_birth }}
      </f7-block>
      <f7-list no-hairlines-md>
        <f7-list-item>
           <span>{{ $t('address-birth_place_valid') }}</span>
           <f7-toggle v-model:checked="pob_valid" :disabled="(pob_locality=='')"></f7-toggle>
        </f7-list-item>
        <f7-list-item divider></f7-list-item>
      </f7-list>
</span>
place of birth -->
      <!-- address -->
      <f7-block-title>{{ $t('address-title') }}</f7-block-title>
      <f7-list no-hairlines-md>
        <f7-list-item 
          id="ss_county"
          :disabled="address_valid"
          :title="$t('address-county_title')" smart-select 
          :smart-select-params="{searchbar: true, closeOnSelect:true, scrollToSelectedItem:true, setValueText:true}"
          >
          <select name="sel_county" @change="address_county=$event.target.value">
            <option v-for="item in county_list" :value="item.code" :selected="item.code==address_county">{{ item.name }}</option>
          </select>
        </f7-list-item>
        <f7-list-input
          type="select"
          :disabled="address_valid"
          :label="$t('address-locality_type_title')" 
          :value="address_locality_type"
           @change="address_locality_type=$event.target.value.trim()"
          >
          <option v-for="item in locality_type_list" :value="item.code" :selected="item.code==address_locality_type">{{ item.name }}</option>
        </f7-list-input>
<!--
        <f7-list-item 
          id="ss_locality"
          :disabled="address_valid"
          :title="$t('address-locality_info')" smart-select
          :smart-select-params="{searchbar: true, closeOnSelect:true, scrollToSelectedItem:true, setValueText:true}"
          >
          <select name="sel_locality" @change="address_locality_siruta=$event.target.value">
            <option v-for="item in locality_short_list" :id="item.code" :name="address_locality_siruta" :value="item.code" :selected="item.code==address_locality_siruta">{{ item.name }}</option>
          </select>
        </f7-list-item>
-->
        <f7-list-input 
          type="text" 
          :disabled="address_valid"
          :placeholder="$t('address-locality_placeholder')" 
          :label="$t('address-locality_info')" 
          :value="address_locality" 
          @input="address_locality=$event.target.value.trim()" 
          >
        </f7-list-input>

        <f7-list-input 
          v-if="address_county==='B'" 
          type="text" 
          :disabled="address_valid" 
          :placeholder="$t('without')" 
          :label="$t('address-sector_info')" 
          :value="address_sector" 
          @input="address_sector=$event.target.value.trim()" 
          >
        </f7-list-input>

        <f7-list-item v-show="address_locality_type.substr(0,3).toUpperCase()=='SAT'||address_locality_type.substr(0,3).toUpperCase()=='LOC'" divider title='Unitatea administrativă'></f7-list-item>
        <f7-list-input
          v-show="address_locality_type.substr(0,3).toUpperCase()=='SAT'||address_locality_type.substr(0,3).toUpperCase()=='LOC'"
          type="select"
          disabled
          :title="$t('address-admin_type_title')"
          :value="address_admin_type"
          @change="address_admin_type=$event.target.value.trim()"
          >
          <option v-for="item in admin_type_list" :value="item.code" :selected="item.code==address_admin_type">{{ item.name }}</option>
        </f7-list-input>
        <f7-list-input 
          v-show="address_locality_type.substr(0,3).toUpperCase()=='SAT'||address_locality_type.substr(0,3).toUpperCase()=='LOC'"
          type="text" 
          disabled
          :placeholder="$t('without')" 
          :label="address_admin_type"
          :value="address_admin" 
          @input="address_admin=$event.target.value.trim()" 
          >
        </f7-list-input>


        <f7-list-item divider></f7-list-item>
        <f7-list-input
          type="select"
          :disabled="address_valid"
          :label="$t('address-street_type_title')"
          :value="address_street_type"
          @change="address_street_type=$event.target.value.trim()"
          >
          <option v-for="item in street_type_list" :value="item.code" :selected="item.code==address_street_type">{{ item.name }}</option>
        </f7-list-input>
        <f7-list-input 
          type="text"
          :disabled="address_valid"
          :placeholder="$t('without')" 
          :label="$t('address-street_info')" 
          :value="address_street" 
          @input="address_street=$event.target.value.trim()" 
          >
        </f7-list-input>
        <f7-list-input 
          type="text" 
          :disabled="address_valid" 
          :placeholder="$t('without')" 
          :label="$t('address-street_no_info')" 
          :value="address_street_no" 
          @input="address_street_no=$event.target.value.trim()" 
          >
        </f7-list-input>

        <f7-list-item divider></f7-list-item>
        <f7-list-input
          type="select"
          :disabled="address_valid" 
          :label="$t('address-building_type_title')" 
          :value="address_building_type"
          @change="address_building_type=$event.target.value.trim()"
          >
          <option v-for="item in building_type_list" :value="item.code" :selected="item.code==address_building_type">{{ item.name }}</option>
        </f7-list-input>

        <f7-list-input 
          type="text" 
          :disabled="address_valid" 
          :placeholder="$t('without')" 
          :label="building_type_info" 
          :value="address_building" 
          @input="address_building=$event.target.value.trim()"
          >
        </f7-list-input>
        <f7-list-input 
          type="text" 
          :disabled="address_valid" 
          :placeholder="$t('without')" 
          :label="$t('address-entrance_info')" 
          :value="address_entrance" 
          @input="address_entrance=$event.target.value.trim()"
          >
        </f7-list-input>
        <f7-list-input 
          type="text" 
          :disabled="address_valid" 
          :placeholder="$t('without')" 
          :label="$t('address-floor_info')" 
          :value="address_floor" 
          @input="address_floor=$event.target.value.trim()"
          >
        </f7-list-input>
        <f7-list-input 
          type="text" 
          :disabled="address_valid" 
          :placeholder="$t('without')" 
          :label="$t('address-unit_info')" 
          :value="address_unit" 
          @input="address_unit=$event.target.value.trim()"
          >
        </f7-list-input>
      </f7-list>
      <f7-block strong inset>
        {{ address_line_1 }}<br/>
        {{ address_line_2 }}<br/>
        {{ address_line_3 }}
      </f7-block>
      <f7-list>
        <f7-list-group>
          <f7-list-item>
            <span>{{ $t('address-valid') }}</span>
            <f7-toggle v-model:checked="address_valid" :disabled="(address_line_1=='') && (address_line_2=='') && (address_line_3=='')"></f7-toggle>
          </f7-list-item>
          <f7-list-item divider></f7-list-item>
          <!-- f7-list-item link="#" :disabled="!address_valid || !pob_valid" @click="saveAddress" >{{ address_done_text }}</f7-list-item-->
          <f7-list-item link="#" :disabled="!address_valid" @click="saveAddress" >{{ address_done_text }}</f7-list-item>
        </f7-list-group>
      </f7-list>
    </span>

    <span v-if="progress==80">
      <!-- otp is true, we can start video-->
      <span v-if="otp">
        <f7-block>
          <Markdown :source="markdown_otp" />
        </f7-block>
        <f7-list>
          <f7-list-item link="/video/">{{ $t('video-start') }}</f7-list-item>
        </f7-list>
      </span>
      <!-- else wait for sms -->
      <span v-else>
        <f7-block>
          <Markdown :source="markdown_video" />
        </f7-block>
        <f7-list>
          <f7-list-item link="#" @click="otp = set_otp()">{{ $t('send-otp') }}</f7-list-item>
        </f7-list>
      </span>
    </span>

    <!-- CAMERA POP-UP, WebRTC -->
    <f7-popup class="camera-popup popup popup-tablet-fullscreen" @popup:closed="toggleCamera(null)">
      <f7-page bg-color="black" text-color="white">
        <span v-if="is_camera_open" v-show="!is_loading" id="video-container">
          <video class="video_register" v-show="!is_photo_taken" ref="camera" playsinline autoplay @click="takePhoto"></video>
          <canvas v-show="is_photo_taken" ref="canvas">CAPTURE</canvas>

          <span v-if="photo_type=='SELFIE' && progress==50">
            <canvas class="canvas-overlays overlay-selfie-indicator" ref="selfieoverlay"></canvas>
          </span>

          <span v-if="orientation=='H' && progress >= 60">
            <canvas class="canvas-overlays overlay-horizontal-document" ref="iddocoverlay"></canvas>
          </span>
          <span v-if="orientation=='V' && progress >= 60">
            <canvas class="canvas-overlays overlay-vertical-document" ref="iddocoverlay"></canvas>
          </span>

          <div class="button_close_photo">
            <f7-link href="#" outline popup-close><f7-icon f7="xmark_circle_fill" size="64px" color="white"></f7-icon></f7-link>
          </div>
          <div class="button_take_photo" ref="button_take_photo"> 
            <f7-link href="#" @click="takePhoto"><f7-icon f7="camera_circle_fill" size="64px" color="white"></f7-icon></f7-link>
          </div>
        </span>
        <span v-show="is_camera_open && is_loading">{{ $t('register_status-opening-camera') }}</span>
      </f7-page>
    </f7-popup>

  </f7-page>
</template>

<script>
  import Markdown from 'vue3-markdown-it';
  import { getDevice, getSupport } from 'framework7';
  import { useStore, f7 } from 'framework7-vue'; 
  import { useTimer } from 'vue-timer-hook';
  import { utils, request } from 'framework7';
  import { watchEffect } from "vue";
  import $$ from 'dom7';
  import VOtpInput from 'vue3-otp-input';
  import QrcodeVue from 'qrcode.vue'

  export default {
    setup() {
      const loading = useStore('loading');

      const county_list = useStore('county_list');
      const country_list = useStore('country_list');
      const admin_type_list = useStore('admin_type_list');
      const building_type_list = useStore('building_type_list');
      const floor_list = useStore('floor_list');
      const locality_type_list = useStore('locality_type_list');
      const street_type_list = useStore('street_type_list');
      const place_of_birth_list = useStore('place_of_birth_list');

      const loadLists = () => { 
        f7.store.dispatch('getAdminTypeList');
        f7.store.dispatch('getBuildingTypeList');
        f7.store.dispatch('getCountyList');
        f7.store.dispatch('getCountryList');
        f7.store.dispatch('getFloorList');
        f7.store.dispatch('getLocalityTypeList');
        f7.store.dispatch('getStreetTypeList');
      };

      return {
        loading,
        admin_type_list,
        building_type_list,
        county_list,
        country_list,
        floor_list,
        locality_type_list,
        street_type_list,
        place_of_birth_list,
        loadLists,
      };
    },
    props: {
      f7route: Object,
      f7router: Object,
      markdown_idcard: String,
      markdown_otp: String,
      markdown_rotation: String,
      markdown_selfie: String,
      markdown_video: String,
      national_id_keycloak: String,
    },
    components: {
      Markdown,
      VOtpInput,
      QrcodeVue,
    },
    data() {
      return {
        locality_list: null,
        locality_short_list: null,
        address_valid:false,
        pob_valid:true,
        authority_valid:false,
        debug: false,
        bio: false,
        email: null,
        email_is_valid: false,
        id: false,
        is_mobile:false,
        camera_mobile:false,
        national_id: null,
        national_id_ro: false,
        national_id_is_valid: false,
        phone_number: null,
        phone_number_is_valid: false,
        photo_type: null,
        progress: 9999,
        registered: false,
        session:null,
        std_height:800,
        std_width:600,
        tc: false,
        url_image: null,
        // WebRTC
        is_camera_open: false,
        is_loading: false,
        is_photo_taken: false,
        is_photo_taken_and_show: false,
        is_shot_photo: false,
        canvas_identity_document: null,
        canvas_selfie: null,
        // Timer
        unwatch: null,
        timer: null,
        seconds: 60,
        show_reminder: true,
        continue_btn_text: this.$t('all_info_mandatory'),
        // address
        address_county: null,
        address_locality_type: null,
        address_locality: null,
        address_sector: null,
        address_admin_type: null,
        address_admin: null,
        address_street_type: null,
        address_street: null,
        address_street_no: null,
        address_building_type: null,
        address_building: null,
        address_entrance: null,
        address_floor: null,
        address_unit: null,
        address_locality_siruta: null,
        // place of birth
        pob_country: null,
        pob_county: null,
        pob_locality: null,
        // authority
        authority: null,
        // token
        get token() {
          return localStorage.getItem('token');
        },
        set token(value) {
          localStorage.setItem('token', value);
        },
        captcha_min_score: 0.5,
        orientation: 'H',
        // pin
        pin_email: null,
        pin_sms: null,
        phone_number_verify_attempts: 3,
        email_verify_attempts: 3,
        // flags
        work_in_progress: false,
        http500_show_alert: true,
        // capture element supported
        capture_attr_supported: false,
        // sms sent
        otp: false,
        href: '',
      };
    },
    computed: {
      idcard_logo: function() {
        const self=this;
        if(self.orientation=='H') {
          return "../assets/idh.jpg";
        } else {
          return "../assets/idv.jpg";
        }
      },
      idcard_orientation_text: function() {
        const self=this;
        if(self.orientation=='H') {
          return self.$t('idcard-orientation_text_h');
        } else {
          return self.$t('idcard-orientation_text_v');
        }
      },
      building_type_info: function() {
        const self=this;
        if(self.building_type_list && self.address_building_type) {
          let o=self.building_type_list.find(x=>x.code===self.address_building_type);
          if(o)
            return o.name;
        }
        return '';
      },
      address_line_1: function() {
        const self=this;

        if(self.county_list && self.address_county!='B') {
          let o=self.county_list.find(x=>x.code===self.address_county);
          if(o)
            return " Jud."+o.name;
        }
        return '';
      },
      address_line_2: function() {
        const self=this;
        let line=(self.address_locality_type || "") + (self.address_locality || "")
          +(self.address_admin ? " (" + self.address_admin_type + " " + self.address_admin + ")" : "")
          +(self.address_county=="B" ? " Sec."+self.address_sector : "");
        return line;
      },
      address_line_3: function() {
        const self=this;
        let line=(self.address_street_type||"")+
          (self.address_street||"")+
          (self.address_street_no?" nr."+self.address_street_no:"")+
          (self.address_building?" "+self.address_building_type+self.address_building:"")+
          (self.address_entrance?" sc."+self.address_entrance:"")+
          (self.address_floor?" et."+self.address_floor:"")+
          (self.address_unit?" ap."+self.address_unit:"")
        return line;
      },
      place_of_birth: function() {
        const self=this;
        var line = "";
        var o;

        if(self.country_list) {
          o=self.country_list.find(x=>x.code===self.pob_country);
          if(o)
            line = o.name;
        }

        if(self.county_list && self.pob_county!='B') {
          o=self.county_list.find(x=>x.code===self.pob_county);
          if(o)
            line = line + " Jud."+o.name;
        }

        line = line + (self.pob_locality||"");
        return line;
      },
      address_done_text: function() {
        const self=this;
        if(self.address_valid && self.pob_valid)
          return self.$t('continue');
        else
          return self.$t('address-must_validate');
      },
      p2_next_disabled: function() {
        const self=this;
        const ok_to_continue=(this.email_is_valid && this.national_id_is_valid && this.phone_number_is_valid);
        if(ok_to_continue)
          self.continue_btn_text=self.$t('continue');
        else
          self.continue_btn_text=this.$t('all_info_mandatory');
        return !ok_to_continue;
      },
    },
    mounted() {
      const self=this;
      const device=getDevice();
      const support=getSupport();
      const urlPieces=[location.protocol, '//', location.host, location.pathname];

      self.href=urlPieces.join('');

      //self.checkCaptureSupported();
      //self.checkAcceptInputSupported();

      self.is_mobile=((!device.desktop)&&(support.touch));
      self.camera_mobile=self.is_mobile;
      self.is_mobile=false;

      f7.preloader.show();
      self.loadLists();

      /* why do we need the address here? shall we add a step condition? */
      request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        method: 'post',
        url: '/v/address',
        success: function(data, status, xhr) {
          console.log(data);
          f7.preloader.hide();
          if(data.pass) {
            self.progress=data.progress;
            if(data.address) {
              self.iniAddress(data);
            }
          }
        },
        error: function(xhr, status, message, options) {
          f7.preloader.hide();
          self.http500( xhr, status, message);
        },
        dataType: 'json',
      });

      if (localStorage.token) { self.token=localStorage.token; }
      // if (localStorage.progress) { self.progress=localStorage.progress; }
      if (localStorage.registered) { self.registered=localStorage.registered; }
      if (localStorage.orientation) { self.orientation=localStorage.orientation; }
      if (self.national_id_keycloak) { 
        self.national_id=self.national_id_keycloak;
        self.national_id_ro=true;
      }
      f7.preloader.hide();
    },
    watch: {
      registered: function(newRegistered, oldRegistered) {
        localStorage.registered=newRegistered;
      },
/*
      address_county: function(newCounty, oldCounty) {
        const self = this;
        if(newCounty!=oldCounty) {
          if(oldCounty) {
            self.address_admin_cls = null;
            self.address_admin = null;
            self.address_locality_cls = null;
            self.address_locality = null;
          }

          self.getLocalityList();

          let el = f7.smartSelect.get("#ss_locality .smart-select");
          if(el) {
            el.setValue(self.address_locality);
          }
        }
      },
      /* 
      pob_county: function(newPobCounty, oldPobCounty) {
        console.log(oldPobCounty + ' => ' + newPobCounty);
        f7.store.dispatch('getPlaceOfBirthList', { 'county': newPobCounty });
        f7.store.dispatch('getCountryList');
      }
*/
    },
    methods: {
      setAddressLocality(id) {
        const self=this;
        var e = self.locality_list.find(function(element) {
          return element.code == id;
        });
        if(e) {
          self.address_admin_type = null;
          self.address_admin = null;
          if(e.locality_cls!=e.superior_cls) {
            self.address_admin_type = e.superior_cls;
            self.address_admin = e.superior;
          }
          self.address_locality_type = e.locality_cls;
          self.address_locality = e.locality;
        }
      },
      showAddressLocality(item) {
        const self=this;
        var loc = item.locality_cls + ' ' + item.locality;
        if(item.locality==item.superior && item.locality_cls==item.superior_cls)
          return loc;
        else
          return loc + ' (' + item.superior_cls + ' ' + item.superior + ')';
      },
      printPinChangeEmail() {
        const self=this;
        const in_array=self.$refs.otpEmail.otp;
      },
      // save address
      saveAddress() {
        console.log("saveAddress");
        const self=this;
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: '/v/address', 
          data: {
            'pob_country':self.pob_country,
            'pob_county':self.pob_county,
            'pob_locality':self.pob_locality,
            'pob_sector':self.pob_sector,
            'county':self.address_county,
            'locality_type':self.address_locality_type,
            'locality':self.address_locality,
            'sector':self.address_sector,
            'street_type':self.address_street_type,
            'street':self.address_street,
            'street_no':self.address_street_no,
            'building_type':self.address_building_type,
            'building':self.address_building,
            'entrance':self.address_entrance,
            'floor':self.address_floor,
            'unit':self.address_unit,
            'full_address':self.address_line_1+" "+self.address_line_2+" "+self.address_line_3,
          },
          success: function (data, status, xhr) { 
            if(data.pass) {
              self.progress=data.progress;
              f7.preloader.hide();
            } else {
              f7.preloader.hide();
            }
          },
          error: function (xhr, status, message) {
            f7.preloader.hide();
            self.http500( xhr, status, message);
          },
          dataType: 'json',
        })
      },
      // capture image
      captureImage(photo_type) {
        const self=this;
        if(self.is_mobile) {
          self.photo_type=photo_type;
          self.$refs.input_image.click();
        } else {
          self.toggleCamera(photo_type);
        }
      },
      // check if the "capture" html attribute is supported.
      checkCaptureSupported(){
        const self = this;
        let tmpCapture = document.createElement('input');
        if ('capture' in tmpCapture){
          f7.dialog.alert("capture attribute is supported", "testing");
          self.capture_attr_supported = true;
        }
        else{
          f7.dialog.alert("capture attribute is NOT supported in this browser.", "testing");
          self.capture_attr_supported = false;
        }
      },
      checkAcceptInputSupported(){
        const self = this;
        let tmpAccept = document.createElement('input');
        if ('accept' in tmpAccept){
          f7.dialog.alert("accept attribute is supported", "testing");
        }
        else{
          f7.dialog.alert("accept attribute is NOT supported in this browser.", "testing");
        }
      },
      // FILE FUNCTIONS - HTML5 capture
      loadFile(photo_type) {
        const self=this;
        const fileReader=new FileReader();
        const file=self.$refs.input_image.files[0];

        fileReader.onload=function() {
          var image=new Image();
          image.onload=function() {
            var canvas=document.createElement("canvas");
            var context=canvas.getContext("2d");
            var factor=1;
            if(image.width>self.std_width) {
              factor=image.width/self.std_width;
            }
            canvas.width=image.width/factor;
            canvas.height=image.height/factor;
            context.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
            self.url_image=canvas.toDataURL("image/jpeg");

            f7.preloader.show();
            request({
              beforeSend: function (xhr) {
                xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
              },
              method: 'post',
              url: '/v/image', 
              data: {
                photo_type: self.photo_type,
                file: self.url_image,
              },
              success: function (data, status, xhr) {
                f7.preloader.hide();
                if(data.pass) {
                  f7.popup.close();
                  self.progress=data.progress;
                  if(self.progress==75)
                    self.address(data);
                  if(self.progress==65)
                    self.orientation=data.orientation;
                } else {
                  f7.dialog.alert("("+data.err_code+" - "+data.photo_type+") "+data.err_msg);
                }
              },
              error: function (xhr, status, message) {
                f7.preloader.hide();
                self.http500( xhr, status, message);
              },
              dataType: 'json'
            });
          }
          image.src=fileReader.result;
        }
        fileReader.readAsDataURL(file);
      },
      addTextToContext(text, context, overlayY){
        const ctx = context;
        const canvas = ctx.canvas;
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        ctx.font = "18px Arial";
        ctx.fillStyle = "#4AF626";
        ctx.textAlign = "center";

        const maxWidth = canvasWidth * 0.8;
        const lineHeight = 22;
        const textX = canvasWidth / 2;
        const textY = overlayY - 60;

        function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
          const words = text.split(' ');
          let line = '';
          let yPosition = y;

          for (let i = 0; i < words.length; i++) {
            let testLine = line + words[i] + ' ';
            let testWidth = ctx.measureText(testLine).width;

            if (testWidth > maxWidth && i > 0) {
              ctx.fillText(line, x, yPosition);
              line = words[i] + ' ';
              yPosition += lineHeight;
            } else {
              line = testLine;
            }
          }
          ctx.fillText(line, x, yPosition);
        }

        wrapText(ctx, text, textX, textY, maxWidth, lineHeight);
      },
      
      resizeCanvasOverlay() {
        const self = this;
        const video = self.$refs.camera;
        const canvas = self.canvas_identity_document ? self.canvas_identity_document : self.canvas_selfie;

        if (!video || !canvas) {
          //console.log("no valid canvas found");
          return;
        }

        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;

        if (videoWidth === 0 || videoHeight === 0) {
          //console.warn("Video dimensions are not loaded yet.");
          return;
        }

        const videoAspectRatio = videoWidth / videoHeight;
        const containerAspectRatio = video.offsetWidth / video.offsetHeight;

        if (containerAspectRatio > videoAspectRatio) {
          canvas.width = video.offsetHeight * videoAspectRatio;
          canvas.height = video.offsetHeight;
        } else {
          canvas.width = video.offsetWidth;
          canvas.height = video.offsetWidth / videoAspectRatio;
        }

        const videoRect = video.getBoundingClientRect();
        canvas.style.position = "absolute";
        canvas.style.width = `${videoRect.width}px`;
        canvas.style.height = `${videoRect.height}px`;
      },

      drawCanvasRoundedRect(x, y, width, height, radius) {
        const self = this;
        const ctx = self.canvas_identity_document.getContext('2d');

        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
      },

      drawSelfieOverlay(overlayWidth, overlayHeight) {
        const self = this;
        const ctx = self.canvas_selfie.getContext('2d');

        if (!ctx) {
          //console.warn("Canvas context for selfie is not available.");
          return;
        }

        const canvasWidth = self.canvas_selfie.width;
        const canvasHeight = self.canvas_selfie.height;

        const ovalWidth = canvasWidth * overlayWidth;
        const ovalHeight = canvasHeight * overlayHeight;
        const ovalX = (canvasWidth - ovalWidth) / 2;
        const ovalY = (canvasHeight - ovalHeight) / 2;

        ctx.clearRect(0, 0, canvasWidth, canvasHeight);

        ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);

        ctx.save();
        ctx.beginPath();
        ctx.ellipse(
          ovalX + ovalWidth / 2, // centerX
          ovalY + ovalHeight / 2, // centerY
          ovalWidth / 2, // radiusX
          ovalHeight / 2, // radiusY
          0, // rotation
          0,
          2 * Math.PI
        );
        ctx.clip();
        ctx.clearRect(ovalX, ovalY, ovalWidth, ovalHeight);
        ctx.restore();

        // border draw
        ctx.strokeStyle = 'white';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.ellipse(
          ovalX + ovalWidth / 2,
          ovalY + ovalHeight / 2,
          ovalWidth / 2,
          ovalHeight / 2,
          0,
          0,
          2 * Math.PI
        );
        ctx.stroke();

        self.addTextToContext(self.$t('indications-selfie_overlay_positioning'), ctx, ovalY);
      },

      drawCanvasOverlay(rectWidthRatio, rectHeightRatio) {
        const self = this;
        const ctx = self.canvas_identity_document.getContext('2d');

        const rectWidth = self.canvas_identity_document.width * rectWidthRatio; // e.g., 0.90 for 90%
        const rectHeight = self.canvas_identity_document.height * rectHeightRatio; // e.g., 0.35 for 35%
        const rectX = (self.canvas_identity_document.width - rectWidth) / 2;
        const rectY = (self.canvas_identity_document.height - rectHeight) / 2;
        const borderRadius = 10;

        ctx.clearRect(0, 0, self.canvas_identity_document.width, self.canvas_identity_document.height);

        ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
        ctx.fillRect(0, 0, self.canvas_identity_document.width, self.canvas_identity_document.height);

        ctx.save();
        self.drawCanvasRoundedRect(rectX, rectY, rectWidth, rectHeight, borderRadius);
        ctx.clip();
        ctx.clearRect(rectX, rectY, rectWidth, rectHeight);
        ctx.restore();

        ctx.strokeStyle = 'white';
        ctx.lineWidth = 2;
        self.drawCanvasRoundedRect(rectX, rectY, rectWidth, rectHeight, borderRadius);
        ctx.stroke();

        self.addTextToContext(self.$t('indications-idcard_overlay_positioning'), ctx, rectY);

      },
      
      updateCanvasOverlay() {
        const self = this;
        if (!self.is_camera_open || self.is_loading || !self.camera_mobile){
          return;
        }

        self.resizeCanvasOverlay();
        console.log("updating the canvas overlay");
        if (self.canvas_identity_document != null && self.canvas_identity_document.classList.contains('overlay-horizontal-document')) {
          self.drawCanvasOverlay(0.90, 0.35);
        } else if (self.canvas_identity_document != null && self.canvas_identity_document.classList.contains('overlay-vertical-document')) {
          self.drawCanvasOverlay(0.80, 0.63);
        }
        else if (self.canvas_selfie != null && self.canvas_selfie.classList.contains('overlay-selfie-indicator')){
          self.drawSelfieOverlay(0.68, 0.48);
        }
      },
      // CAMERA WebRTC functions 
      toggleCamera(photo_type) {
        const self=this;
        self.photo_type=photo_type;
        if(self.is_camera_open) {
          self.is_camera_open=false;
          self.is_photo_taken=false;
          self.is_shot_photo=false;
          self.stopCameraStream();
          f7.navbar.show("#navbar");
          f7.toolbar.show("#toolbar");
        } else {
          f7.popup.open(".camera-popup");
          self.is_camera_open=true;
          self.createCameraElement();
        }
      },
      createCameraElement() {
        const self=this;
        self.is_loading=true;
        const constraints=(window.constraints={
          audio: false,
          video: {
            width: { 'min': 640, 'ideal': 1280, 'max': 1920, },
            height: { 'min': 480, 'ideal': 720, 'max': 1080, },
            facingMode: { ideal: (this.photo_type=='SELFIE') ? 'user' : 'environment', }
          },
        });
        
        navigator.mediaDevices.getUserMedia(constraints, {data: null}).
          then((mediaStream) => {
            self.is_loading=false;
            self.$refs.camera.srcObject=mediaStream;
            f7.navbar.hide("#navbar");
            f7.toolbar.hide("#toolbar");
            const camera = self.$refs.camera;
            if(self.photo_type=="IDENTITY") {
              camera.setAttribute('style', 'webkitTransform:scaleX(1);transform:scaleX(1)');
            }

            self.canvas_identity_document = self.$refs.iddocoverlay;
            self.canvas_selfie = self.$refs.selfieoverlay;
            if (self.canvas_identity_document != null || self.canvas_selfie != null){
              console.log("adding the listeners to the video element");
              window.addEventListener('resize', self.updateCanvasOverlay);
              camera.addEventListener('loadeddata', self.updateCanvasOverlay);
            }
            else{
              console.log("failed to find the identity document or selfie overlay objects");
            }

          })
          .catch((error) => {
            console.log(error);
            self.is_loading=false;
          });

        if(self.is_loading==false) {
          constraints=(window.constraints={
            audio: false,
            video: {
              width: { 'min': 640, 'ideal': 1280, 'max': 1920, },
              height: { 'min': 480, 'ideal': 720, 'max': 1080, },
            },
          });

          navigator.mediaDevices.getUserMedia(constraints, {data: null}).
            then((mediaStream) => {
              self.is_loading=false;
              self.$refs.camera.srcObject=mediaStream;
              f7.navbar.hide("#navbar");
              f7.toolbar.hide("#toolbar");
              const camera = self.$refs.camera;
            })
            .catch((error) => {
              console.log(error);
              self.is_loading=false;
              f7.dialog.alert(self.$t('error_no_webrtc_support') + self.$t('general_contact_email'));
              window.location.reload();
            });
        }
      },
      stopCameraStream() {
        const self=this;
        try {
          let tracks=this.$refs.camera.srcObject.getTracks();
          tracks.forEach(track=> {
            track.stop();
          });
        } catch(error) {
        }
      },
      takePhoto() {
        const self=this;
        if(!this.is_photo_taken) {
          self.is_shot_photo=true;
          const FLASH_TIMEOUT=50;
          setTimeout(()=> {
            self.is_shot_photo=false;
          }, FLASH_TIMEOUT);
        }

        self.is_photo_taken=!this.is_photo_taken;

        const video=this.$refs.camera;
        const canvas=this.$refs.canvas;
        const context=canvas.getContext('2d');

        canvas.width=video.videoWidth;
        canvas.height=video.videoHeight;
        canvas.style.display="none";

        context.drawImage(video, 0, 0)
        self.url_image=canvas.toDataURL("image/jpeg");
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: '/v/image',
          data: {
            photo_type: self.photo_type,
            file:self.url_image,
          },
          success: function (data, status, xhr) {
            f7.preloader.hide();
            if(data.pass) {
              f7.popup.close();
              self.progress=data.progress;
              if(self.progress==75) {
                self.iniAddress(data);
              }
              if(self.progress==65)
                self.orientation=data.orientation;
            } else {
              f7.dialog.alert("("+data.err_code+" - "+data.photo_type+") "+data.err_msg);
              self.is_photo_taken=!self.is_photo_taken;
            }
          },
          error: function (xhr, status, message) {
            f7.preloader.hide();
            self.toggleCamera(null);
            self.http500( xhr, status, message);
          },
          dataType: 'json',
        });
      },
      iniAddress(data) {
        const self=this;

        self.address_county=data.address.county;
        self.address_locality_type=data.address.locality_type;
        self.address_locality=data.address.locality;
        self.address_sector=data.address.sector;
        self.address_admin_type=data.address.admin_type;
        self.address_admin=data.address.admin;
        self.address_street_type=data.address.street_type;
        self.address_street=data.address.street;
        self.address_street_no=data.address.street_no;
        self.address_building_type=data.address.building_type;
        self.address_building=data.address.building;
        self.address_entrance=data.address.entrance;
        self.address_floor=data.address.floor;
        self.address_unit=data.address.unit;
        self.address_locality_siruta=data.address.locality_siruta;

        self.authority=data.authority.reconstructed;

        self.pob_country=data.place_of_birth.country;
        self.pob_county=data.place_of_birth.county;
        self.pob_locality=data.place_of_birth.locality;
      },
      getLocalityList() {
        const self = this;
        console.log("getLocalityList");
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: '/store/locality_list',
          data: {
            county: self.address_county,
          },
          success: function (data, status, xhr) {
            f7.preloader.hide();
            if(data) {
              self.locality_list = data.long_list;
              self.locality_short_list = data.short_list;
              console.log(self.locality_short_list);
/*
                let ss_locality=f7.smartSelect.get('#ss_locality .smart-select');
                if(ss_locality) {
                  console.log("set ss_locality to " + self.address_locality_siruta);
                  ss_locality.setValue(self.address_locality_siruta);
                }
*/
            }
          },
          error: function (xhr, status, message) {
            f7.preloader.hide();
            self.toggleCamera(null);
            self.http500( xhr, status, message);
          },
          dataType: 'json',
        });
      },
      // TERMINATE 
      terminate() {
        const self=this;
        f7.dialog.confirm(
          self.$t('cancel-text'),
          self.$t('cancel'),
          ()=> {
            self.f7router.navigate('/cancel');
          },
          ()=> {
            console.log("cancel cancelled");
          });
      },
      // progress #1
      agree(event) {
        const self=this;
        const value=event.target.value;
        if(event.target.name=="tc") 
          self.tc=event.target.checked;
        if(event.target.name=="bio") 
          self.bio=event.target.checked;
        if(event.target.name=="id") 
          self.id=event.target.checked;
        if(self.bio & self.tc & self.id)
          f7.dialog.confirm(
            self.$t('start-text'),
            self.$t('start'),
            ()=> {
              f7.preloader.show();
              request({
                beforeSend: function (xhr) {
                  xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
                },
                method: 'post',
                url: "/v/agree",
                data: {
                  agree_bio: self.bio,
                  agree_tc: self.tc,
                },
                success: function(data, status, xhr) {
                  f7.preloader.hide();
                  if(data.pass) {
                    self.progress=data.progress;
                  }
                },
                error: function(xhr, status, message) {
                  f7.preloader.hide();
                  self.id=false;
                  self.http500( xhr, status, message);
                },
                dataType: 'json'
              });
            },
            ()=>{
              self.id=false;
            });
      },
      // PERSONAL DATA
      setEmailValid(isValid) {
        const self=this;
        self.email_is_valid=isValid;
      },
      setCnpValid(isValid) {
        const self=this;
        self.national_id_is_valid=isValid;
      },
      setTelValid(isValid) {
        const self=this;
        self.phone_number_is_valid=isValid;
      },

      /* progress #2 */
      personal() {
        const self=this;
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: "post",
          url: "/v/personal", 
          data: {
            email: self.email,
            national_id: self.national_id,
            phone_number: self.phone_number,
            phone_number_country: 'RO',
          },
          success: function(data, status, xhr) {
            f7.preloader.hide();
            if(data.pass) {
              self.progress=data.progress;
            } else {
              f7.dialog.alert("("+data.err_code+") "+data.err_msg);
            }
          },
          error: function(xhr, status, message) {
            f7.preloader.hide();
            self.http500(xhr, status, message);
          },
          complete: function() {
            self.work_in_progress=false;
          },
          dataType: 'json'
        });
      },

      // recaptcha_id = 2
      async personal_validation() {
        const self = this;
        f7.preloader.show();
        await this.$recaptchaLoaded();
        const g_token = await this.$recaptcha('personalvalidation');
        if(g_token != null){
          request({
            beforeSend: function (xhr) {
              self.work_in_progress=true;
              xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
            },
            method: 'post' ,
            url: '/v/captcha',
            data: {          
              'response': g_token,
              'id': 2,
              'recaptcha': 'personalvalidation'
            },
            success: function (data, status, xhr) {
              f7.preloader.hide();
              if(data.pass)
                self.personal();
              else 
                f7.dialog.alert(self.$t('recaptcha_robot-detected'),self.$t('error'));
            },
            error: function (xhr, status, message) {
              f7.preloader.hide();
              self.http500(xhr, status, message);
            },
            dataType: 'json'
          });              
        } else {
          f7.preloader.hide();
          f7.dialog.alert('Tokenul returnat este null (reCAPTCHA)');
        }
      },
      
      // CHECK PINS
      verifyPinEmail(event) {
        const self=this;
        self.work_in_progress=true; 
        const in_array=self.$refs.otpEmail.otp;
        self.pin_email=in_array.join('');
        self.pin_validation(self.pin_email, 'EMAIL', 'emailpinvalidation', 3);
      },
      verifyPinPhone(event) {
        const self=this;
        self.work_in_progress=true; 
        const in_array=self.$refs.otpPhone.otp;
        self.pin_sms=in_array.join('');
        self.pin_validation(self.pin_sms, 'SMS', 'phonepinvalidation', 4);
      },
      async pin_validation(pin_value, pin_type, pin_recaptcha, pin_id){
        const self = this;
        f7.preloader.show();
        await this.$recaptchaLoaded();
        const g_token = await this.$recaptcha(pin_recaptcha);
        if(g_token != null){
          request({
            beforeSend: function (xhr) {
              xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
            },
            method: 'post',
            url: '/v/captcha',
            data: {
              'response': g_token,
              'id': pin_id,
              'recaptcha': pin_recaptcha
            },
            success: function (data, status, xhr) {
              f7.preloader.hide();
              if(data.pass)
                self.verifyPin(pin_value, pin_type);
              else 
                f7.dialog.alert(self.$t('recaptcha_robot-detected'),self.$t('error'));
            },
            error: function (xhr, status, message) {
              f7.preloader.hide();
              self.http500(xhr, status, message);
            },
            dataType: 'json'
          });
        } else{
          f7.preloader.hide();
          f7.dialog.alert('Tokenul returnat este null (reCAPTCHA)');
        }
      },
      verifyPin(pin_value,pin_type) {
        const self=this;
        if(pin_type=='EMAIL')
          self.$refs.otpEmail.clearInput();
        else
          self.$refs.otpPhone.clearInput();
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method:"post",
          url: "/v/pin", 
          data: {
            pin: pin_value,
            pin_type: pin_type,
          },
          success: function(data, status, xhr) {
            f7.preloader.hide();
            if(pin_type=='EMAIL')
              self.email_verify_attempts=data.attempts;
            else
              self.phone_number_verify_attempts=data.attempts;

            if(data.pass) {
              self.progress=data.progress;
            } else{
              f7.dialog.alert(
                self.$t('general_incorrect-code-label')+" "+self.$t('pin_remaining-attempts',data.attempts), 
                ()=>{ 
                  self.pin_email=null;
                  self.pin_sms=null;
                  self.work_in_progress=false;
                  // $$('input.input-with-value').focus();
                  if(pin_type=='EMAIL') {
                    self.$refs.otpEmail.clearInput();
                    self.$refs.otpEmail.focusInput(0);
                  } else {
                    self.$refs.otpPhone.clearInput();
                    self.$refs.otpPhone.focusInput(0);
                  }
                }
              );
            }
          },
          error: function(xhr, status, message) {
            f7.preloader.hide();
            self.http500(xhr, status, message);
          },
          complete: function() {
            self.work_in_progress=false;
          },
          dataType: 'json'});
      },
      set_otp() {
        const self=this;
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: "/v/set_otp",
          success: function(data, status, xhr) {
            f7.preloader.hide();
            if(data.pass) {
              self.otp=true;
            }
          },
          error: function(xhr, status, message) {
            f7.preloader.hide();
            self.http500( xhr, status, message);
          },
          dataType: 'json'
        });
      },
      /* common treatment for all errors */
      http500(xhr, status, message) {
        const self = this;
        f7.emit('request_error', xhr, status, message, self);
      },
      // CLEAN-UP
      cleanup() {
        const self=this;
        self.reset_local_vars();
        // localStorage.clear();
      },
      reset_local_vars() {
        const self=this;
        self.tc=false;
        self.bio=false;
        self.id=false;
      },
      // PAGE EVENTS
      onPageBeforeRemove() {
        const self=this;
        try {
          if(self.popup) self.popup.destroy();
        } catch(error) {
          console.log(error);
        }
        if(self.notificationReminder) self.notificationReminder.destroy();
        if(self.notificationIdle) self.notificationIdle.destroy();
      },
      onPageAfterOut() {
        const self=this;
        self.timer=null;
        f7.notification.close();
      },
    // END METHODS.
    },
  };  
</script>
